// xams-utils
import { check } from '@xams-utils/check-types';

// internal
import * as ERRORS from './errors';
var integerType = function integerType(integer) {
  if (!check.integer(integer)) {
    throw ERRORS.INTEGER_TYPE;
  }
};
var numberType = function numberType(number) {
  if (!check.number(number)) {
    throw ERRORS.NUMBER_TYPE;
  }
};
var maxGreaterThanMin = function maxGreaterThanMin(min, max) {
  if (min >= max) {
    throw ERRORS.MIN_MAX;
  }
};
var validate = {
  integerType: integerType,
  numberType: numberType,
  maxGreaterThanMin: maxGreaterThanMin
};
export { validate };